import getDefaultMarkerNameFromMarkersArray from '@/helpers/getDefaultMarkerNameFromMarkersArray';
import { Breakpoint } from '@/models/app.model';
import {
    MapPoint, MarkersData, RoomData, TransformedMarkersData,
} from '@/models/markers-data.model';
import idGenerator from '@/helpers/idGenerator';
import { getImageExtension } from '@/helpers/supportedBrowsers';
import { verQuery } from '@/helpers/assetsVersionForCache';
import transformNameIntoLabel from './transformNameIntoLabel';

const markersConfigTransformer = {
    transform(markersConfig: MarkersData, assetsPath: string, breakpoint: Breakpoint, hasWebpImages: boolean):
    TransformedMarkersData {
        let defaultMarkerName = '';

        if (markersConfig.defaultMarker) {
            defaultMarkerName = markersConfig.defaultMarker;
        } else {
            defaultMarkerName = getDefaultMarkerNameFromMarkersArray(markersConfig.markers);
        }

        const transformed: TransformedMarkersData = {
            rooms: [],
            defaultRoomName: defaultMarkerName,
            points: [],
            defaultPoint: defaultMarkerName,
            map: markersConfig.map,
            northAngle: markersConfig.northAngle,
        };

        const getId = idGenerator();

        markersConfig.markers.forEach((marker) => {
            const label = transformNameIntoLabel(marker.name);
            const room: RoomData = {
                label,
                name: marker.name,
                imgPath: `${assetsPath}/${breakpoint}/${marker.name}${getImageExtension(hasWebpImages)}?${verQuery}`,
                markers: [],
                rotation: marker.rotation,
                floor: marker.floor || 0,
            };

            marker.visibleMarkers.forEach((visibleMarker) => {
                room.markers.push({
                    html: transformNameIntoLabel(visibleMarker.name),
                    roomName: visibleMarker.name,
                    position: {
                        x: visibleMarker.x,
                        y: visibleMarker.y,
                    },
                    redirectTo: visibleMarker.redirectTo,
                    id: `${getId.next().value}`,
                });
            });

            transformed.rooms.push(room);

            const point: MapPoint = {
                label,
                roomName: marker.name,
                floor: marker.floor || 0,
                position: {
                    top: marker.y,
                    left: marker.x,
                },
            };

            transformed.points.push(point);
        });

        return transformed;
    },
};

export default markersConfigTransformer;
